import React, { useState } from "react";
import {
  TouchableOpacity,
  StatusBar,
  StyleSheet,
  Text,
  TextInput,
  View,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import { useDispatch } from "react-redux";
import { saveMedical } from "../store/medicalSlice";

const MedicalScreen = () => {
  const [berat, setBerat] = useState("");
  const [tinggi, setTinggi] = useState("");
  const [riwayatPenyakit, setRiwayatPenyakit] = useState("Asma");
  const [penyakit, setPenyakit] = useState("");
  const [alergiMakanan, setAlergiMakanan] = useState("");
  const [alergiObat, setAlergiObat] = useState("");
  const [activeInsuranceTab, setActiveInsuranceTab] = useState("BPJS");
  const [insurance, setInsurance] = useState("");

  const navigation = useNavigation();
  const dispatch = useDispatch();

  const medical = () => {
    {
      berat &&
        tinggi &&
        riwayatPenyakit &&
        alergiMakanan &&
        alergiObat &&
        activeInsuranceTab &&
        dispatch(
          saveMedical({
            berat: berat,
            tinggi: tinggi,
            riwayatPenyakit: riwayatPenyakit,
            penyakit: penyakit,
            alergiMakanan: alergiMakanan,
            alergiObat: alergiObat,
            activeInsuranceTab: activeInsuranceTab,
            insurance: insurance,
          })
        );
    }

    {
      berat &&
      tinggi &&
      riwayatPenyakit &&
      alergiMakanan &&
      alergiObat &&
      activeInsuranceTab
        ? navigation.navigate("Home")
        : navigation.navigate("Home");
    }
  };

  return (
    <View style={styles.medical}>
      <Text style={styles.medicalTitle}>Rekam Medis</Text>

      <View style={styles.medicalInput}>
        <Text style={styles.medicalInputText}>Berat Badan</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="78"
          keyboardType="number-pad"
          style={styles.medicalInputTextInput}
          onChangeText={(berat) => setBerat(berat)}
          defaultValue={berat}
        />
      </View>

      <View style={styles.medicalInput}>
        <Text style={styles.medicalInputText}>Tinggi Badan</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="175"
          keyboardType="number-pad"
          style={styles.medicalInputTextInput}
          onChangeText={(tinggi) => setTinggi(tinggi)}
          defaultValue={tinggi}
        />
      </View>

      <View style={styles.medicalInput}>
        <Text style={[styles.medicalInputText, { marginBottom: 10 }]}>
          Riwayat Penyakit
        </Text>
        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
          <DiseaseButton
            text="Asma"
            btnColor="black"
            textColor="white"
            activeTab={riwayatPenyakit}
            setActiveTab={setRiwayatPenyakit}
          />
          <DiseaseButton
            text="Maag"
            btnColor="white"
            textColor="black"
            activeTab={riwayatPenyakit}
            setActiveTab={setRiwayatPenyakit}
          />
          <DiseaseButton
            text="Varises"
            btnColor="white"
            textColor="black"
            activeTab={riwayatPenyakit}
            setActiveTab={setRiwayatPenyakit}
          />
          <DiseaseButton
            text="TBC"
            btnColor="white"
            textColor="black"
            activeTab={riwayatPenyakit}
            setActiveTab={setRiwayatPenyakit}
          />
          <DiseaseButton
            text="Darah Tinggi"
            btnColor="white"
            textColor="black"
            activeTab={riwayatPenyakit}
            setActiveTab={setRiwayatPenyakit}
          />
          <DiseaseButton
            text="Epilepsi"
            btnColor="white"
            textColor="black"
            activeTab={riwayatPenyakit}
            setActiveTab={setRiwayatPenyakit}
          />
          <DiseaseButton
            text="STD"
            btnColor="white"
            textColor="black"
            activeTab={riwayatPenyakit}
            setActiveTab={setRiwayatPenyakit}
          />
          <DiseaseButton
            text="Bronchitis"
            btnColor="white"
            textColor="black"
            activeTab={riwayatPenyakit}
            setActiveTab={setRiwayatPenyakit}
          />
          <DiseaseButton
            text="Lain-lain"
            btnColor="white"
            textColor="black"
            activeTab={riwayatPenyakit}
            setActiveTab={setRiwayatPenyakit}
          />
        </View>
        {riwayatPenyakit === "Lain-lain" && (
          <TextInput
            autoCapitalize="none"
            autoCorrect={false}
            placeholder="Lain-lain"
            keyboardType="default"
            style={styles.medicalInputTextInput}
            onChangeText={(penyakit) => setPenyakit(penyakit)}
            defaultValue={penyakit}
          />
        )}
      </View>

      <View style={styles.medicalInput}>
        <Text style={styles.medicalInputText}>Alergi Makanan</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="Udang"
          keyboardType="default"
          style={styles.medicalInputTextInput}
          onChangeText={(alergiMakanan) => setAlergiMakanan(alergiMakanan)}
          defaultValue={alergiMakanan}
        />
      </View>

      <View style={styles.medicalInput}>
        <Text style={styles.medicalInputText}>Alergi Obat</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="Penicilin"
          keyboardType="default"
          style={styles.medicalInputTextInput}
          onChangeText={(alergiObat) => setAlergiObat(alergiObat)}
          defaultValue={alergiObat}
        />
      </View>

      <View style={styles.medicalInput}>
        <Text style={[styles.medicalInputText, { marginBottom: 10 }]}>
          Asuransi
        </Text>
        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
          <InsuranceButton
            text="BPJS"
            btnColor="black"
            textColor="white"
            activeTab={activeInsuranceTab}
            setActiveTab={setActiveInsuranceTab}
          />
          <InsuranceButton
            text="AIA"
            btnColor="white"
            textColor="black"
            activeTab={activeInsuranceTab}
            setActiveTab={setActiveInsuranceTab}
          />
          <InsuranceButton
            text="AXA"
            btnColor="white"
            textColor="black"
            activeTab={activeInsuranceTab}
            setActiveTab={setActiveInsuranceTab}
          />
          <InsuranceButton
            text="Manulife"
            btnColor="white"
            textColor="black"
            activeTab={activeInsuranceTab}
            setActiveTab={setActiveInsuranceTab}
          />
          <InsuranceButton
            text="Allianz"
            btnColor="white"
            textColor="black"
            activeTab={activeInsuranceTab}
            setActiveTab={setActiveInsuranceTab}
          />
          <InsuranceButton
            text="Lain-lain"
            btnColor="white"
            textColor="black"
            activeTab={activeInsuranceTab}
            setActiveTab={setActiveInsuranceTab}
          />
        </View>
        {activeInsuranceTab === "Lain-lain" && (
          <TextInput
            autoCapitalize="none"
            autoCorrect={false}
            placeholder="Lain-lain"
            keyboardType="default"
            style={styles.medicalInputTextInput}
            onChangeText={(insurance) => setInsurance(insurance)}
            defaultValue={insurance}
          />
        )}
      </View>

      <TouchableOpacity onPress={medical}>
        <View style={styles.medicalButton}>
          <Text style={styles.medicalButtonText}>
            {berat &&
            tinggi &&
            riwayatPenyakit &&
            alergiMakanan &&
            alergiObat &&
            activeInsuranceTab
              ? "Simpan Rekam Medis"
              : "Kembali"}
          </Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default MedicalScreen;

const DiseaseButton = (props: any) => (
  <TouchableOpacity
    style={{
      backgroundColor: props.activeTab === props.text ? "#FF2828" : "#F8F8F8",
      paddingVertical: 3,
      paddingHorizontal: 10,
      borderRadius: 30,
      height: 30,
      maxWidth: 150,
      alignItems: "center",
      justifyContent: "center",
      marginHorizontal: 2,
    }}
    onPress={() => props.setActiveTab(props.text)}
  >
    <Text
      style={{
        color: props.activeTab === props.text ? "#F8F8F8" : "black",
        fontSize: 16,
        fontWeight: "500",
      }}
    >
      {props.text}
    </Text>
  </TouchableOpacity>
);

const InsuranceButton = (props: any) => (
  <TouchableOpacity
    style={{
      backgroundColor: props.activeTab === props.text ? "#FF2828" : "#F8F8F8",
      paddingVertical: 3,
      paddingHorizontal: 10,
      borderRadius: 30,
      height: 30,
      maxWidth: 150,
      alignItems: "center",
      justifyContent: "center",
      marginHorizontal: 2,
    }}
    onPress={() => props.setActiveTab(props.text)}
  >
    <Text
      style={{
        color: props.activeTab === props.text ? "#F8F8F8" : "black",
        fontSize: 16,
        fontWeight: "500",
      }}
    >
      {props.text}
    </Text>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  medical: {
    flex: 1,
    backgroundColor: "#F8F8F8",
    paddingTop: StatusBar.currentHeight,
    paddingHorizontal: "15%",
  },
  medicalTop: {
    display: "flex",
  },
  medicalBackButton: {
    backgroundColor: "#FF2828",
    borderRadius: 100,
    padding: 10,
    marginRight: 20,
  },
  medicalTitle: {
    fontSize: 30,
    fontWeight: "500",
    marginTop: 50,
    marginBottom: 20,
  },
  medicalInput: {
    marginBottom: 20,
  },
  medicalInputText: {
    color: "#FF2828",
    fontSize: 16,
    fontWeight: "500",
  },
  medicalInputTextInput: {
    fontSize: 16,
    fontWeight: "500",
    placeholderTextColor: "#bbb",
    borderBottomWidth: 1,
    borderBottomColor: "#bbb",
    marginTop: 10,
  },
  medicalButton: {
    backgroundColor: "#FF2828",
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 5,
    marginTop: 20,
  },
  medicalButtonText: {
    color: "#F8F8F8",
    fontWeight: "500",
    fontSize: 16,
  },
});
